<template>
    <div>
      <van-nav-bar
        title="代金券"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/member/members')"
      />
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="backgroud">
          <br>
          <van-row >
            <van-col span="8"> </van-col>
            <van-col span="8">
              <div class="capital-box1">
                <div class="capital-header">
                  <img src="../assets/images/timebao.png" alt="">
                  <h5>代金券</h5>
                </div>
                <br>
                <p>{{ voucher_management }} 元</p>
              </div>
            </van-col>
            <van-col span="8"
              ><div class="capital-box">
                <router-link :to="{ name: 'DetailedLog', params: { tab: 6 } }"
                  ><h5 style="color: #0D268D">账单 ></h5>
                  </router-link
                >
              </div></van-col
            >
          </van-row>
        </div>
        <br>
        
      </van-pull-refresh>
    </div>
  </template>
  
  <script>
  export default {
    name: "Voucher",
    data() {
      return {
        isLoading: false,
        voucher_management: 0,
      };
    },
    computed: {},
    methods: {
      isLogin() {
        let that = this;
        if (!that.$store.state.loginType) {
          that.$router.push("/login");
        }
      },
      mainMethod() {
        this.getUserinfo();
      },
      onRefresh() {
        this.mainMethod();
        this.isLoading = false;
      },
      getUserinfo() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token"),
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.voucher_management = res.data.data.voucher_management;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
  
    },
    mounted() {
      this.getUserinfo();
    },
  };
  </script>
  
  <style scoped>
  .navstyles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
  
  .capital {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  
  .capital h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    color: #000000;
  }
  
  .capital p {
    margin: 0;
    color: #D02E27;
    font-size: 14px;
    font-weight: bold;
  }
  
  .capital-box {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .capital-box1 {
    height: 60px;
    display: flex;
    align-items: left;
    justify-content: center;
    flex-direction: column;
  }
  
  
  .capital-box h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 300;
    color: #000000;
  }
  .capital-box1 h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 300;
    color: #000000;
  }
  
  .capital-box p {
    margin: 0;
    color: #D02E27;
    font-size: 18px;
    font-weight: bold;
  }
  .capital-box1 p {
    margin: 0;
    color: #D02E27;
    font-size: 18px;
    font-weight: bold;
  }
  .capital-btn {
    margin-top: 10px;
    text-align: center;
  }
  .capital-header {
    margin-top: 5px;
    display: flex;
    align-items: center; /* Align items in the same line */
  }
  
  .capital-header img {
    width: 25px;  
    height: 25x; 
    margin-right: 5px; 
    margin-top: -2px;
  }
  
  .backgroud {
      margin:10px 10px 5px 10px !important;
      border:1px solid #e3e3e3!important;
      border-radius: 20px !important;
      overflow: hidden;
      height: 100px;
    }
  .button-in{
    background-color: #D02E27 !important;
    border: 1px solid #D02E27!important;
  }
  .button-out{
    background-color: #0D268D !important;
    border: 1px solid #0D268D!important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Voucher.vue